<template>
  <v-container fluid class="ux-payments">
    <!-- ===== NAV (sticky, glass) ===== -->
    <header class="nav">
      <div class="nav__left">
        <div class="nav__inputs">
          <v-text-field
              v-model.number="filters.contractId"
              :label="$t('Kontrakt') + ' ID'"
              dense outlined hide-details clearable
              prepend-inner-icon="mdi-magnify"
              @keyup.enter="applyFilters"
              class="w-56"
          />
          <v-text-field
              v-model="filters.pinfl"
              label="PINFL"
              dense outlined hide-details clearable
              append-icon="mdi-card-account-details-outline"
              @keyup.enter="applyFilters"
              class="w-56 pinfl-input"
          />
          <!-- From -->
          <DatePicker
            :value="localDates.from"
            @input="onPickFrom"
            @clear="clearDateFrom"
            label="Dan"
            icon="mdi-calendar-start"
            :max="localDates.to || undefined"
            class="w-44"
          />
          <!-- To -->
          <DatePicker
            :value="localDates.to"
            @input="onPickTo"
            @clear="clearDateTo"
            label="Gacha"
            icon="mdi-calendar-end"
            :min="localDates.from || undefined"
            class="w-44"
          />
        </div>
      </div>

      <div class="nav__right">
        <!-- SEGMENTED SOURCE (All, OneC, Manual) styled like "To'langan / Tasdiqlangan" -->
        <div class="seg">
          <button class="seg__btn" :class="{ 'is-active': segPos==='all' }" @click="setSources(null)">All</button>
          <button class="seg__btn" :class="{ 'is-active': segPos==='onec' }" @click="setSources(['OneC'])">1C</button>
          <button class="seg__btn" :class="{ 'is-active': segPos==='manual' }" @click="setSources(['MANUAL'])">Manual</button>
          <span class="seg__fill" :style="segStyle"></span>
        </div>

        <v-btn icon small class="ml-1" @click="resetFilters" :disabled="!filtersActive">
          <v-icon size="18">mdi-backspace-outline</v-icon>
        </v-btn>

        <div>
          <!-- Export button with loading spinner inside -->
          <v-btn
            text
            :loading="exportLoading"
            dark
            :disabled="exportLoading || excelExportDisabled"
            @click="exportToExcel"
            class="excel-btn"
          >
            <template v-slot:loader>
              <v-progress-linear
                :indeterminate="true"
                color="#000"
                class="ml-3 mr-3"
              ></v-progress-linear>
            </template>

            <v-icon left>mdi-upload</v-icon> Export
          </v-btn>
        </div>
      </div>

     

      <v-progress-linear :active="loading" :indeterminate="true" height="2" absolute bottom />
    </header>

    <v-btn
        :key="index"
        :class="['dropdown-btn', 'ma-2', periodPaymentExportDropdown ? 'dropdown-btn__active' : '']"
        outlined
        tile
        @click="togglePeriodPaymentExportDropdown"
    >
      Davr uchun kontrakt to'lov tushumlari.
    </v-btn>

    <header
        v-if="periodPaymentExportDropdown"
        class="nav nav--period">
      <div class="nav__inputs">
          <!-- From -->
          <DatePicker
            :value="localDatesPeriod.from"
            @input="onPickFromPeriodTab"
            @clear="clearDateFromPeriod"
            label="Dan"
            icon="mdi-calendar-start"
            :max="localDatesPeriod.to || undefined"
            class="w-44"
          />
          <!-- To -->
          <DatePicker
            :value="localDatesPeriod.to"
            @input="onPickToPeriodTab"
            @clear="clearDateToPeriod"
            label="Gacha"
            icon="mdi-calendar-end"
            :min="localDatesPeriod.from || undefined"
            class="w-44"
          />
        </div>

       <div class="nav__right">
        <div>
          <!-- Export button with loading spinner inside -->
          <v-btn
            text
            :loading="exportLoadingPeriodTab"
            dark
            :disabled="exportLoadingPeriodTab || excelExportDisabled"
            @click="exportToExcel2"
            class="excel-btn"
          >
            <template v-slot:loader>
              <v-progress-linear
                :indeterminate="true"
                color="#000"
                class="ml-3 mr-3"
              ></v-progress-linear>
            </template>

            <v-icon left>mdi-upload</v-icon> Export 2
          </v-btn>
        </div>
      </div>

    </header>

    
    <!-- ===== /NAV ===== -->

    <!-- ===== COUNTERS + SIMPLE PAGER (no page size chooser) ===== -->
    <section class="counters">
      <div class="counter">
        <div class="counter__label">To'lovlar soni</div>
        <div class="counter__value"><span v-if="!loading">{{ summary.count | fmt }}</span><span v-else class="sk sk--text w80"></span></div>
      </div>
      <div class="counter">
        <div class="counter__label">To'langan miqdor</div>
        <div class="counter__value"><span v-if="!loading">{{ summary.sumPaid | money }}</span><span v-else class="sk sk--text w140"></span></div>
      </div>
      <div class="spacer"></div>
      <div class="pager">
        <v-btn icon :disabled="filters.page<=1" @click="goPage(filters.page-1)"><v-icon>mdi-chevron-left</v-icon></v-btn>
        <div class="muted">Page {{ filters.page }} / {{ totalPages }}</div>
        <v-btn icon :disabled="filters.page>=totalPages" @click="goPage(filters.page+1)"><v-icon>mdi-chevron-right</v-icon></v-btn>
      </div>
    </section>
    <!-- ===== /COUNTERS ===== -->

    <!-- ===== LIST ===== -->
    <v-card class="list">
      <!-- Better skeletons -->
      <template v-if="loading">
        <div v-for="n in 7" :key="'sk'+n" class="srow">
          <div class="srow__icon sk"></div>
          <div class="srow__main">
            <div class="sk sk--title"></div>
            <div class="sk sk--sub"></div>
          </div>
          <div class="srow__chip sk w60"></div>
        </div>
      </template>

      <!-- Empty -->
      <template v-else-if="rows.length===0">
        <div class="empty" style="display:flex; align-items: center; justify-content: center; flex-direction: column; padding-top: 20px; padding-bottom: 20px">
          <v-icon large class="mb-2">mdi-database-off</v-icon>
          <div class="title">Natija yo'q</div>
          <div class="caption">Sana yoki filtrlarni o'zgartiring.</div>
        </div>
      </template>

      <!-- Rows -->
      <transition-group name="fade-up" tag="div">
        <article
            v-for="item in rows"
            :key="item.id"
            class="row"
            :class="['is-' + (item.comingFrom || 'neutral').toString().toLowerCase()]"
        >
          <!-- LEFT ICON (green) -->
          <div class="row__icon">
            <img src="/icons/arrow-down-icon.svg" style="width: 36px; " alt="">
          </div>

          <!-- MAIN -->
          <div class="row__main" @click="toggleOpen(item.id)">
            <div class="row__amount">{{ item.paid | money }}</div> 
            
            <div class="row__sub">
              <span
                class="badge"
                :class="['badge-secondary', 'badge-lg']"
                :data-count="item.year"
              >
                {{ item.year }}
              </span> • 
              {{ formatDate(item.paymentDate) }} 
            </div>
          </div>

          <!-- EXPAND TOGGLE -->
          <div class="row__chev">
            <v-btn style="margin-right: 20px" icon @click.stop="toggleOpen(item.id)">
              <v-icon style="font-size:30px; vertical-align:middle; ">{{ isOpen(item.id) ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
            </v-btn>
          </div>
          

          <!-- DETAILS -->
          <v-expand-transition>
            <div v-show="isOpen(item.id)" class="row__details">
               
              <div class="kv">
                <div class="k">Contract</div><div class="v">#{{ item.contractId || '—' }}</div>
                <div class="k">{{ $t("Source") }}</div>
                <div class="v">
                  <v-chip small :class="['chip--source', chipClass(item.comingFrom)]">
                    <v-icon left small>{{ sourceIcon(item.comingFrom) }}</v-icon>
                    {{ item.comingFrom || '—' }}
                  </v-chip>
                </div>
                <div class="k">{{ $t("Date") }}</div><div class="v">{{ formatDate(item.paymentDate) }}</div>
                <div class="k">{{ $t("Payment") }} ID</div><div class="v">#{{ item.id }}</div>
              </div>
              <div class="detail-actions">
                <v-btn 
                 color="#ffd451"
                style="color: #0f172a;" depressed 
                @click="openContract(item)">
                  <v-icon left>mdi-open-in-new</v-icon> {{ $t('Open Contract') }}
                </v-btn>
              </div>
             
            </div>
          </v-expand-transition>
        </article>
      </transition-group>

      <!-- Minimal bottom pager (no size chooser) -->
      <div class="npager">
        <span class="muted">Total: {{ totalItems | fmt }}</span>
        <v-pagination v-model="filters.page" :length="totalPages" :total-visible="7" />
      </div>
    </v-card>
    <!-- ===== /LIST ===== -->

    <v-snackbar 
      v-model="snack.show"
      :timeout="1500"
      color="#ffd451"
      style="color: #0f172a;"
      :vertical="snack.vertical"
      class="custom-snack"
      top
      right
    >
      {{ snack.text }}
    </v-snackbar>
  </v-container>
</template>

<script>
import axios from "axios";
import DatePicker from "@/components/DatePicker.vue";

export default {
  name: "PaymentsStudentStyle",
  components: { DatePicker },
  data: () => ({
    loading: false,
    fromMenu: false,
    toMenu: false,
    toMenuPeriodTab: false,

    filters: {
      contractId: null,
      pinfl: null,
      dateFrom: null,
      dateFromPeriodTab: null,

      dateTo: null,
      dateToPeriodTab: null,

      minPaid: null,
      maxPaid: null,
      sources: [],
      hasDebt: null,
      page: 1,
      size: 20, // kept but no chooser
      sort: "paymentDate,desc"
    },

    localDates: { from: null, to: null },
    localDatesPeriod: { from: null, to: null },
    dateFromText: '',
    dateToText: '',
    dateFromPeriodText: '',
    dateToPeriodText: '',

    rows: [],
    totalItems: 0,
    summary: { count: 0, sumPaid: 0 },
    openRows: {},

    debouncer: null,
    snack: { show: false, text: "" },
    exportLoading: false,
    exportLoadingPeriodTab: false,
    periodPaymentExportDropdown: false,
  }),

  computed: {
    totalPages() {
      return Math.max(1, Math.ceil(this.totalItems / (this.filters.size || 20)));
    },
    filtersActive() {
      const f = this.filters;
      return !!(f.contractId || f.pinfl || f.dateFrom || f.dateTo || f.minPaid || f.maxPaid || (f.sources && f.sources.length) || f.hasDebt !== null);
    },
    segPos() {
      if (!this.filters.sources || this.filters.sources.length === 0) return "all";
      if (this.filters.sources[0] === "OneC") return "onec";
      if (this.filters.sources[0] === "MANUAL") return "manual";
      return "all";
    },
    segStyle() {
      const base = { left: "2px" };
      if (this.segPos === "onec") base.left = "calc((100% - 4px) / 3 + 2px)";
      if (this.segPos === "manual") base.left = "calc((100% - 4px) / 3 * 2 + 2px)";
      return base;
    }
  },

  watch: {
    "filters.contractId": "debouncedFetch",
    "filters.pinfl": "debouncedFetch",
    "filters.minPaid": "debouncedFetch",
    "filters.maxPaid": "debouncedFetch",
    "filters.sources": "debouncedFetch",
    "filters.hasDebt": "debouncedFetch",
    "filters.page"(n, o) { if (n !== o) this.fetchAll(); }
  },

  created() {
    this.fetchAll();
  },

  methods: {
    isOpen(id) { return !!this.openRows[id]; },
    toggleOpen(id) { this.$set(this.openRows, id, !this.openRows[id]); },

    openContract(paymentItem) {
      if (paymentItem.year == "2026") {
        this.$router.push(`/contract_2026_2027-show/${paymentItem.contractId}`)
      } else if (paymentItem.year == "2025") {
        this.$router.push(`/contract_2025_2026-show/${paymentItem.contractId}`)
      } else if (paymentItem.year == "2024") {
        this.$router.push(`/contract_2024_2025-show/${paymentItem.contractId}`)
      } else if (paymentItem.year == "2023") {
        this.$router.push(`/contract_2023_2024-show/${paymentItem.contractId}`)
      } else if (paymentItem.year == "2022") {
        this.$router.push(`/contract_2022_2023-show/${paymentItem.contractId}`)
      } else {
        this.snack = { show: true, text: 'Contract view not available for this year.' };
      }
    },

    async fetchAll() {
      try {
        this.loading = true;
        const [page, sum] = await Promise.all([
          this.fetchPayments(this.filters),
          this.fetchSummary(this.filters)
        ]);
        this.rows = page.items || [];
        this.totalItems = page.totalItems || 0;
        this.summary = {
          count: Number(sum?.count || 0),
          sumPaid: Number(sum?.sumPaid || 0)
        };
      } catch (e) {
        this.snack = { show: true, text: e?.response?.data?.message || e?.message || 'Failed to load' };
      } finally {
        this.loading = false;
      }
    },

    async fetchPayments(filter) {
      const { data } = await axios.post("/admin/payment2025/search", filter);
      return data;
    },

    async fetchSummary(filter) {
      const { data } = await axios.post("/admin/payment2025/stats/summary", filter);
      return data;
    },

    applyFilters() {
      this.filters.page = 1;
      this.fetchAll();
    },

    resetFilters() {
      this.filters = {
        contractId: null,
        pinfl: null,
        dateFrom: null,
        dateTo: null,
        minPaid: null,
        maxPaid: null,
        sources: [],
        hasDebt: null,
        page: 1,
        size: this.filters.size, // preserved internally
        sort: "paymentDate,desc"
      };
      this.localDates = { from: null, to: null };
      this.dateFromText = '';
      this.dateToText = '';
      this.applyFilters();
    },

    goPage(p) {
      this.filters.page = Math.min(Math.max(1, p), this.totalPages);
    },

    onPickFrom(v) {
      this.localDates.from = v;
      this.filters.dateFrom = v ? new Date(v + "T00:00:00Z").toISOString() : null;
      this.dateFromText = this.dateLabel(this.filters.dateFrom);
      this.applyFilters();
    },

    onPickTo(v) {
      this.localDates.to = v;
      this.filters.dateTo = v ? new Date(v + "T23:59:59Z").toISOString() : null;
      this.dateToText = this.dateLabel(this.filters.dateTo);
      this.applyFilters();
    },

    onPickToPeriodTab(v) {
      this.localDatesPeriod.to = v;
      this.filters.dateToPeriodTab = v ? new Date(v + "T23:59:59Z").toISOString() : null;
      this.dateToPeriodText = this.dateLabel(this.filters.dateToPeriodTab);
    },

    onPickFromPeriodTab(v) {
      this.localDatesPeriod.from = v;
      this.filters.dateFromPeriodTab = v ? new Date(v + "T00:00:00Z").toISOString() : null;
      this.dateFromPeriodText = this.dateLabel(this.filters.dateFromPeriodTab);
    },

    dateLabel(iso) {
      if (!iso) return "";
      const d = new Date(iso);
      const dd = String(d.getDate()).padStart(2, "0");
      const mm = String(d.getMonth() + 1).padStart(2, "0");
      const yyyy = d.getFullYear();
      return `${dd}.${mm}.${yyyy}`;
    },

    onDateInput(val, target) {
      const digits = (val || '').replace(/\D/g, '').slice(0, 8);
      let formatted = digits;
      if (digits.length > 4) {
        formatted = digits.slice(0, 2) + '.' + digits.slice(2, 4) + '.' + digits.slice(4);
      } else if (digits.length > 2) {
        formatted = digits.slice(0, 2) + '.' + digits.slice(2);
      }

      const textMap = { from: 'dateFromText', to: 'dateToText', fromPeriod: 'dateFromPeriodText', toPeriod: 'dateToPeriodText' };
      this[textMap[target]] = formatted;

      if (digits.length === 8) {
        const dd = parseInt(digits.slice(0, 2));
        const mm = parseInt(digits.slice(2, 4));
        const yyyy = parseInt(digits.slice(4, 8));
        if (mm >= 1 && mm <= 12 && dd >= 1 && dd <= 31 && yyyy >= 1900 && yyyy <= 2100) {
          const pickerVal = `${yyyy}-${String(mm).padStart(2, '0')}-${String(dd).padStart(2, '0')}`;
          if (target === 'from') {
            this.localDates.from = pickerVal;
            this.filters.dateFrom = new Date(pickerVal + 'T00:00:00Z').toISOString();
            this.fromMenu = false;
            this.applyFilters();
          } else if (target === 'to') {
            this.localDates.to = pickerVal;
            this.filters.dateTo = new Date(pickerVal + 'T23:59:59Z').toISOString();
            this.toMenu = false;
            this.applyFilters();
          } else if (target === 'fromPeriod') {
            this.localDatesPeriod.from = pickerVal;
            this.filters.dateFromPeriodTab = new Date(pickerVal + 'T00:00:00Z').toISOString();
            this.fromMenuPeriodTab = false;
          } else if (target === 'toPeriod') {
            this.localDatesPeriod.to = pickerVal;
            this.filters.dateToPeriodTab = new Date(pickerVal + 'T23:59:59Z').toISOString();
            this.toMenuPeriodTab = false;
          }
        }
      }
    },

    clearDateFrom() {
      this.localDates.from = null;
      this.filters.dateFrom = null;
      this.dateFromText = '';
      this.applyFilters();
    },

    clearDateTo() {
      this.localDates.to = null;
      this.filters.dateTo = null;
      this.dateToText = '';
      this.applyFilters();
    },

    clearDateFromPeriod() {
      this.localDatesPeriod.from = null;
      this.filters.dateFromPeriodTab = null;
      this.dateFromPeriodText = '';
    },

    clearDateToPeriod() {
      this.localDatesPeriod.to = null;
      this.filters.dateToPeriodTab = null;
      this.dateToPeriodText = '';
    },

    formatDate(iso) {
      if (!iso) return "";
      const d = new Date(iso);
      const y = d.getFullYear();
      const m = String(d.getMonth() + 1).padStart(2, "0");
      const dd = String(d.getDate()).padStart(2, "0");
      return `${dd}.${m}.${y}`;
    },

    debouncedFetch() {
      clearTimeout(this.debouncer);
      this.debouncer = setTimeout(() => this.applyFilters(), 220);
    },

    setSources(val) {
      this.filters.sources = val || [];
      this.applyFilters();
    },

    chipClass(src) {
      if (src === "OneC") return "chip--onec";
      if (src === "MANUAL") return "chip--manual";
      return "chip--neutral";
    },

    sourceIcon(src) {
      if (src === "OneC") return "mdi-database";
      if (src === "MANUAL") return "mdi-account-edit";
      return "mdi-tag";
    },

    async exportToExcel() {
      this.exportLoading = true;          // show spinner + progress bar

      try {
        const response = await axios.post(
          '/admin/payment2025/search/export',
          this.filters,
          {
            responseType: 'blob',
            headers: { 'Content-Type': 'application/json' },

            // ---- OPTIONAL: show real % if the server sends Content-Length ----
            onDownloadProgress: (progressEvent) => {
              if (progressEvent.lengthComputable) {
                const percent = Math.round(
                  (progressEvent.loaded * 100) / progressEvent.total
                );
                // If you want a *determinate* bar, store `percent` in data
                // and bind `:value="percent"` on the <v-progress-linear>
                console.log('Download %:', percent);
              }
            },
          }
        );

        // ---- Build & trigger download ----
        const blob = new Blob([response.data], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute(
          'download',
          `payments-${new Date().toISOString().slice(0, 10)}.xlsx`
        );
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);

        this.snack = { show: true, text: 'Export successful!' };
      } catch (error) {
        console.error('Export failed:', error);
        this.snack = { show: true, text: 'Export failed!' };
      } finally {
        this.exportLoading = false;        // hide spinner & progress bar
      }
    },

    togglePeriodPaymentExportDropdown() {
      this.periodPaymentExportDropdown = !this.periodPaymentExportDropdown;
    },

    async exportToExcel2() {
      this.exportLoadingPeriodTab = true;          // show spinner + progress bar

      try {
        const response = await axios.post(
          '/admin/payment2025/period/export',
          { dateFrom: this.filters.dateFromPeriodTab, dateTo: this.filters.dateToPeriodTab },
          {
            responseType: 'blob',
            headers: { 'Content-Type': 'application/json' },

            // ---- OPTIONAL: show real % if the server sends Content-Length ----
            onDownloadProgress: (progressEvent) => {
              if (progressEvent.lengthComputable) {
                const percent = Math.round(
                  (progressEvent.loaded * 100) / progressEvent.total
                );
                // If you want a *determinate* bar, store `percent` in data
                // and bind `:value="percent"` on the <v-progress-linear>
                console.log('Download %:', percent);
              }
            },
          }
        );

        // ---- Build & trigger download ----
        const blob = new Blob([response.data], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute(
          'download',
          `payments-${new Date().toISOString().slice(0, 10)}.xlsx`
        );
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);

        this.snack = { show: true, text: 'Export successful!' };
      } catch (error) {
        console.error('Export failed:', error);
        this.snack = { show: true, text: 'Export failed!' };
      } finally {
        this.exportLoadingPeriodTab = false;        // hide spinner & progress bar
      }
    },

  },

  filters: {
    money(v) {
      if (v == null) return "0";
      return Number(v).toLocaleString("uz-UZ");
    },
    fmt(v) {
      if (v == null) return "0";
      return Number(v).toLocaleString("uz-UZ");
    }
  },

};
</script>

<style lang="scss" scoped>
/* =============================
   Student-portal vibe + fixes
   ============================= */
.ux-payments{
  --bg: #f6f7fb;
  --glass-from: rgba(255,255,255,.92);
  --glass-to: rgba(255,255,255,.84);
  --card: #fff;
  --line: rgba(2,6,23,.08);
  --muted: rgba(15,23,42,.62);
  --elev-1: 0 1px 0 rgba(2,6,23,.04);
  --elev-2: 0 10px 24px rgba(2,6,23,.10);

  --green: #16a34a; --green-bg: #16a34a14; --green-br: #16a34a33;
  --onec-bg: #2563eb14; --onec-br: #2563eb33; --onec-tx: #1e40af;
  --manual-bg:#10b98114;--manual-br:#10b98133;--manual-tx:#065f46;

  background: var(--bg);
  padding-top: 8px;
}

/* Dark mode overrides moved to unscoped style block below */

/* ============ NAV ============ */
/* A stacking level of its own. In dark mode the glass backdrop-filter makes .nav a stacking context,
   so its date pickers' dropdowns cannot rise above it; without a z-index the list card (a positioned
   v-card further down) painted over an open calendar. The period bar sits a level lower so the main
   bar's calendar drops over it. position also anchors the loading bar to the nav's bottom edge. */
.nav{
  position: relative; z-index: 3;
  display:flex; align-items:center; justify-content:space-between;
  gap: 8px;
  padding: 8px 10px;
  background: var(--card);
  border: 1px solid var(--line);
  border-radius: 14px;
  box-shadow: var(--elev-1);
  overflow: visible;
}

.nav--period{ z-index: 2; }

.nav__left{ display:flex; align-items:center; gap:8px; flex:1 1 0; min-width:0; }
.nav__title{ font-size:18px; font-weight:800; margin:0 8px 0 2px; color:#0f172a; }
.nav__inputs{ display:flex; gap:8px; align-items:center; flex:1 1 0; min-width:0; }
.nav__right{ display:flex; align-items:center; gap:8px; flex-shrink:0; }
.w-56{ flex: 1 1 120px; min-width: 0; }
.w-44{ flex: 1 1 100px; min-width: 0; }

/* Segmented control (3 options) */
.seg{
  position: relative;
  display:grid; grid-template-columns: repeat(3, 1fr);
  background:#f1f5f9; border:1px solid var(--line);
  border-radius: 999px; padding:2px; height:34px; min-width: 160px; width: 190px;
  align-items:center; overflow:hidden;
  flex-shrink: 0;
}
.seg__btn{
  z-index:2; appearance:none; border:0; background:transparent;
  padding: 4px 10px; border-radius: 999px; font-weight:700; font-size:12px;
  color:#475569; cursor:pointer; text-align:center;
}
.seg__btn.is-active{ color:#000; }
.seg__fill{
  position:absolute; top:2px; bottom:2px;
  width: calc((100% - 4px) / 3);
  border-radius: 999px; background:#ffd451;
  transition: left .18s ease;
}

/* ============ COUNTERS ============ */
.counters{
  display:flex; align-items:center; gap:12px;
  margin: 10px 0 12px;
}
.counter{
  background: var(--card);
  border: 1px solid var(--line);
  border-radius: 16px;
  padding: 12px 16px;
  box-shadow: var(--elev-1);
  min-width: 180px;
  &__label{ font-size:12px; color:var(--muted); letter-spacing:.08em; font-weight:800; text-transform:uppercase; }
  &__value{ font-size:28px; font-weight:900; color:#0f172a; line-height:1.15; display:flex; align-items:center; gap:8px; }
}
.counters .spacer{ flex:1; }
.pager{ display:flex; align-items:center; gap:8px; }
.muted{ color: var(--muted); font-size: 12px; }

/* ============ LIST ============ */
.list{
  background: var(--card);
  border: 1px solid var(--line);
  border-radius: 18px;
  overflow: hidden;
  box-shadow: var(--elev-1);
  padding: 4px 0 10px;
}

/* Row */
.row{
  display:grid; grid-template-columns: 64px 1fr auto;
  gap: 12px; align-items: center;
  margin: 10px 12px; padding: 12px;
  border-radius: 16px; border:1px solid var(--line);
  background:#fff; box-shadow: 0 1px 0 rgba(2,6,23,.02);
  transition: transform .12s ease, box-shadow .12s ease, border-color .12s ease;

  &:hover{ transform: translateY(-1px); box-shadow: var(--elev-2); }
}
.row__icon{
  width:56px;height:56px;border-radius:14px;
  display:flex;align-items:center;justify-content:center;
  background: var(--green-bg); border:1px solid var(--green-br); color: var(--green);
}
.row__main{ cursor:pointer; }
.row__amount{ font-size:28px; font-weight:900; color:#0f172a; letter-spacing:.01em; }
.row__sub{ font-size:12px; color:#6b7280; margin-top:2px; }
.row__chev{ display:flex; justify-content:flex-end; }
.row__details{
  grid-column: 1 / -1;
  margin-top: 8px;
  border: 1px dashed var(--line);
  background: #f8fafc;
  border-radius: 14px;
  padding: 12px;
}
.kv{
  display:grid; grid-template-columns: 160px 1fr; row-gap:8px; column-gap:12px;
  .k{ font-size:12px; color:#6b7280; text-transform:uppercase; letter-spacing:.06em; font-weight:800; }
  .v{ font-weight:700; color:#0f172a; }
}
.detail-actions{ margin-top:12px; display:flex; gap:8px; }

/* Chips (for details) */
.chip--source{ background:#fff !important; border:1px solid var(--line) !important; }
.chip--onec{ background: var(--onec-bg) !important; border-color: var(--onec-br) !important; color: var(--onec-tx) !important; }
.chip--manual{ background: var(--manual-bg) !important; border-color: var(--manual-br) !important; color: var(--manual-tx) !important; }

/* Bottom pager */
.npager{
  display:flex; align-items:center; justify-content:space-between;
  padding: 10px 12px; border-top:1px solid var(--line); background:#fafbfd;
}

/* ======= BETTER SKELETONS ======= */
@keyframes shimmer {
  0% { background-position: -450px 0; }
  100% { background-position: 450px 0; }
}
.sk{
  display:inline-block; height: 14px; border-radius: 6px; overflow:hidden;
  background: #eef2f7;
  background-image: linear-gradient(90deg, #eef2f7 0px, #f7f9fc 40px, #eef2f7 80px);
  background-size: 600px 100%;
  animation: shimmer 1.2s infinite linear;
}
.sk--text{ height: 24px; border-radius: 8px; }
.w80{ width: 80px; } .w140{ width: 140px; } .w60{ width: 60px; }

.srow{
  display:grid; grid-template-columns: 56px 1fr 70px; align-items:center; gap:12px;
  margin: 10px 12px; padding: 12px; border-radius: 16px; border:1px solid var(--line); background:#fff;
}
.srow__icon{ width:56px; height:56px; border-radius:14px; }
.srow__main .sk--title{ width: 200px; height: 22px; border-radius:10px; margin-bottom:6px; }
.srow__main .sk--sub{ width: 140px; height: 14px; border-radius: 8px; }

/* Animation */
.fade-up-enter-active, .fade-up-leave-active{ transition: all .18s ease; }
.fade-up-enter, .fade-up-leave-to{ opacity:0; transform: translateY(6px); }

/* Responsive */
@media (max-width: 960px){
  .nav { flex-wrap: wrap; }
  .nav__left { flex: 1 1 100%; }
  .nav__inputs { flex-wrap: wrap; }
  .nav__right { flex: 1 1 100%; justify-content: flex-start; flex-wrap: wrap; }
  .row{ grid-template-columns: 56px 1fr 40px; }
  .kv{ grid-template-columns: 120px 1fr; }
  .counters { flex-wrap: wrap; }
  .counter { min-width: 0; flex: 1 1 100%; }
  .counter__value { font-size: 18px !important; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
}

/* ======= CUSTOM SNACKBAR (shadcn-inspired, no extra classes, NO ROUNDED) ======= */
.custom-snack .v-snackbar__wrapper {
  @apply flex items-center gap-3 border border-border bg-card/95 backdrop-blur-xl p-4 pr-12 shadow-lg ring-1 ring-border/50 transition-all hover:shadow-xl;
}

.custom-snack ::v-deep(.v-snack__content) {
  color: #0f172a !important;
}

.custom-snack .v-snackbar__wrapper::before {
  content: "✓";
  @apply flex h-9 w-9 shrink-0 items-center justify-center bg-emerald-500/15 text-emerald-500 font-bold text-lg leading-none;
}

.custom-snack .v-snackbar__content {
  @apply flex-1 text-sm font-semibold text-foreground tracking-tight;
  font-size: 15px;
  letter-spacing: 0.02em;
}

.custom-snack .v-btn {
  @apply absolute right-3 top-1/2 -translate-y-1/2 p-1.5 text-muted-foreground/70 opacity-0 transition-all hover:bg-accent hover:text-foreground;
  min-width: 36px !important;
  padding: 0 8px !important;
}

.custom-snack .v-btn svg {
  @apply h-4 w-4;
}

.custom-snack:hover .v-btn {
  @apply opacity-100;
}

/* Entrance animation */
.custom-snack .v-snackbar__wrapper {
  animation: toast-in 0.32s cubic-bezier(0.2, 0.8, 0.2, 1);
}

@keyframes toast-in {
  from {
    opacity: 0;
    transform: translateY(16px) scale(0.95);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

.badge {
  display: inline-block;
  padding: 0.25em 0.4em;
  font-size: 75%;
  font-weight: 700;
  line-height: 1;
  text-align: center;
  white-space: nowrap;
  vertical-align: baseline;
  border-radius: 0.25rem;
  color: #fff;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}

.badge-pill {
  padding-right: 0.6em;
  padding-left: 0.6em;
  border-radius: 10rem;
}

.badge-sm {
  font-size: 60%;
  padding: 0.2em 0.3em;
}

.badge-lg {
  font-size: 90%;
  padding: 0.3em 0.5em;
}

.badge-primary { background-color: #007bff; }
.badge-secondary { background-color: #6c757d; }
.badge-success { background-color: #28a745; }
.badge-danger { background-color: #dc3545; }
.badge-warning { background-color: #ffc107; color: #212529; }
.badge-info { background-color: #17a2b8; }
.badge-light { background-color: #f8f9fa; color: #212529; }
.badge-dark { background-color: #343a40; }

.badge:empty {
  display: inline-block;
  width: 0.5em;
  height: 0.5em;
  border-radius: 50%;
  background-color: currentColor;
  padding: 0;
}


.excel-btn {
  border-radius: 8px;
  padding: 8px 20px;
  font-weight: 500;
  display: flex;
  align-items: center;
  gap: 6px;
  text-transform: uppercase;
  background: #ffd451 !important;
  color: #000;
  border: 1.5px solid #ffd451 !important;
  font-weight: 600;
}

.spinner--white {
  color: white !important;
  background-color: #fff;
}

.dropdown-btn {
  font-weight: 600;
  font-size: 14px;
  border-radius: 14px;
  border: 1px solid #d5dbe0;
  color: #2c3e50;
  background-color: #f9f9f9;
  text-transform: none;
  min-width: 200px;
  height: 46px;
}

.dropdown-btn__active {
  font-weight: 600;
  font-size: 14px;
  border-radius: 14px;
  border: 1px solid #d5dbe0;
  color: #2c3e50;
  background-color: #d5dbe0;
  text-transform: none;
  min-width: 200px;
  height: 46px;
}

/* ══════════════════════════════════════════════════════════════
   DARK MODE — scoped overrides for hardcoded colors
   (must live here so [data-v-xxx] specificity matches)
   ══════════════════════════════════════════════════════════════ */
.theme--dark .nav {
  background: rgba(26,27,35,.92) !important;
  -webkit-backdrop-filter: saturate(1.2) blur(12px);
  backdrop-filter: saturate(1.2) blur(12px);
  border-color: rgba(255,255,255,.06);
}
.theme--dark .nav__title { color: #e4e5eb; }
.theme--dark .seg { background: #22232e; border-color: rgba(255,255,255,.06); }
.theme--dark .seg__btn { color: #8b8d9e; }
.theme--dark .seg__btn.is-active { color: #000 !important; }
.theme--dark .counter__value { color: #e4e5eb; }
.theme--dark .counter__label { color: #8b8d9e; }
.theme--dark .list { background: #1a1b23; border-color: rgba(255,255,255,.06); }
.theme--dark .row { background: #1a1b23; border-color: rgba(255,255,255,.06); }
.theme--dark .row:hover { border-color: #33354a; }
.theme--dark .row__amount { color: #e4e5eb; }
.theme--dark .row__sub { color: #8b8d9e; }
.theme--dark .row__details { background: #22232e; border-color: rgba(255,255,255,.06); }
.theme--dark .kv .k { color: #8b8d9e; }
.theme--dark .kv .v { color: #e4e5eb; }
.theme--dark .chip--source { background: #22232e !important; border-color: rgba(255,255,255,.08) !important; color: #d5d6de !important; }
.theme--dark .npager { background: #1a1b23; border-color: rgba(255,255,255,.06); }
.theme--dark .srow { background: #1a1b23; border-color: rgba(255,255,255,.06); }
.theme--dark .sk { background: #22232e; background-image: linear-gradient(90deg, #22232e 0px, #2a2c3a 40px, #22232e 80px); }
.theme--dark .dropdown-btn { background-color: #1a1b23 !important; border-color: #2a2c3a !important; color: #d5d6de !important; }
.theme--dark .dropdown-btn__active { background-color: #22232e !important; border-color: #ffd451 !important; color: #ffd451 !important; }
.theme--dark .excel-btn { background: #ffd451 !important; border-color: #ffd451 !important; color: #111318 !important; }

</style>

<style lang="scss">
/* Dark mode overrides (unscoped so .theme--dark on parent v-app can match) */
.theme--dark .ux-payments {
  --bg: #111318;
  --glass-from: rgba(30,32,48,.92);
  --glass-to: rgba(30,32,48,.84);
  --card: #1a1b23;
  --line: rgba(255,255,255,.06);
  --muted: rgba(228,229,235,.55);
  --elev-1: 0 1px 0 rgba(0,0,0,.12);
  --elev-2: 0 10px 24px rgba(0,0,0,.25);
  --green-bg: rgba(22,163,74,.12);
  --green-br: rgba(22,163,74,.22);
  --onec-bg: rgba(37,99,235,.12);
  --onec-br: rgba(37,99,235,.22);
  --onec-tx: #93b4f8;
  --manual-bg: rgba(16,185,129,.12);
  --manual-br: rgba(16,185,129,.22);
  --manual-tx: #6ee7b7;
  background: var(--bg) !important;
}

.container.ux-payments.container--fluid {
  background: #FFF;
}

/* ── Input styling (unscoped to reach Vuetify internals) ── */
.ux-payments .v-text-field--outlined fieldset {
  border-color: #e2e8f0;
  border-radius: 12px;
}
.ux-payments .v-text-field--outlined:hover fieldset {
  border-color: #cbd5e1;
}
.ux-payments .v-text-field--outlined.v-input--is-focused fieldset {
  border-color: #00274c !important;
  border-width: 2px;
}
.ux-payments .v-text-field--outlined .v-label {
  color: #94a3b8;
  font-weight: 500;
  font-size: 13px;
}
.ux-payments .v-text-field--outlined.v-input--is-focused .v-label {
  color: #00274c !important;
}
.ux-payments .v-text-field--outlined .v-input__prepend-inner .v-icon,
.ux-payments .v-text-field--outlined .v-input__append-inner .v-icon {
  color: #94a3b8 !important;
}
.ux-payments .pinfl-input.v-input--is-focused .v-input__append-inner .v-icon {
  color: #00274c !important;
}
.ux-payments .v-text-field--outlined input {
  font-weight: 600;
  font-size: 13px;
}

/* Dark mode inputs */
.theme--dark .ux-payments .v-text-field--outlined fieldset {
  border-color: #2a2c3a;
}
.theme--dark .ux-payments .v-text-field--outlined:hover fieldset {
  border-color: #3a3d4e;
}
.theme--dark .ux-payments .v-text-field--outlined.v-input--is-focused fieldset {
  border-color: #ffd451 !important;
}
.theme--dark .ux-payments .v-text-field--outlined .v-label {
  color: #6b7280;
}
.theme--dark .ux-payments .v-text-field--outlined.v-input--is-focused .v-label {
  color: #ffd451 !important;
}
.theme--dark .ux-payments .v-text-field--outlined input {
  color: #e4e5eb;
}
.theme--dark .ux-payments .v-text-field--outlined .v-input__prepend-inner .v-icon,
.theme--dark .ux-payments .v-text-field--outlined .v-input__append-inner .v-icon {
  color: #6b7280;
}
.theme--dark .ux-payments .pinfl-input.v-input--is-focused .v-input__append-inner .v-icon {
  color: #e4e5eb !important;
}
.theme--dark .ux-payments .v-text-field--outlined.v-input--is-focused .v-input__prepend-inner .v-icon,
.theme--dark .ux-payments .v-text-field--outlined.v-input--is-focused .v-input__append-inner .v-icon {
  color: #ffd451;
}

/* Segmented control dark */
.theme--dark .ux-payments .seg {
  background: #1a1b23;
  border-color: #2a2c3a;
}
.theme--dark .ux-payments .seg__btn {
  color: #8b8d9e;
}
.theme--dark .ux-payments .seg__btn.is-active {
  color: #111318;
}

/* Counter value dark */
.theme--dark .ux-payments .counter__value {
  color: #e4e5eb;
}

/* TOZALASH / reset button dark */
.theme--dark .ux-payments .v-btn--text {
  color: #8b8d9e !important;
}
.theme--dark .ux-payments .v-btn--text:hover {
  color: #ffd451 !important;
}

/* Nav title dark */
.theme--dark .ux-payments .nav__title {
  color: #e4e5eb;
}

/* Row dark */
.theme--dark .ux-payments .row {
  background: #1a1b23;
}

</style>